module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/citas/citasalta/citasalta.component.scss
// module id = ./src/app/consulta/citas/citasalta/citasalta.component.scss
// module chunks = main